import React, { ReactElement } from 'react';
import { Box } from '@wds/box';
import { createUseStyles } from 'react-jss';

import { HeaderTypeEnum, HeaderImagePropsType } from '../../types';

const useStyles = createUseStyles({
  headerLogo: { height: 100 },
  logo: {
    marginLeft: 'auto',
    marginRight: 'auto',
    objectFit: 'contain',
    maxWidth: '100%',
    flexShrink: 0,
  },
  '@media (min-width: 1024px)': {
    headerLogo: { height: 125 },
  },
});

const Logo = (props: HeaderImagePropsType): ReactElement | null => {
  const { headerType, url, altText } = props;
  const { headerLogo, logo } = useStyles();
  const isPremium = headerType === HeaderTypeEnum.PREMIUM;
  const testId = isPremium ? 'Logo__Premium' : 'Logo__Standard';

  if (!url) {
    return null;
  }

  return (
    <Box className={headerLogo} display="flex" flexJustify="center">
      <img data-testid={testId} className={logo} src={url} alt={altText || ''} />
    </Box>
  );
};

export default Logo;
